import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import Observer from "react-intersection-observer"
import { COLORS, TYPE } from "../../../../../theme/styles/globals"

export default class SocialNineBySixteen extends React.Component {

    render() {

        const { mode, video, uid, label } = this.props

        const color = mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`

        return (
            <InView
                tag="div"
                onChange={inView =>
                    inView
                        ? document.getElementById(`video-${uid}`).play()
                        : document.getElementById(`video-${uid}`).pause()
                }
                rootMargin={"0px 200px"}
            >
                <PhoneWrap>
                    <LabelWrap>
                        <Label color={color}>{label}</Label>
                    </LabelWrap>
                    <PhoneVideo
                        id={`video-${uid}`}
                        autoPlay
                        loop
                        muted
                        playsInline
                    >
                        <source src={video} type="video/mp4" />
                    </PhoneVideo>
                    <Phone
                        x={0}
                        y={0}
                        viewBox="0 0 358 690"
                        xmlSpace="preserve"
                    >
                        <path
                            style={{
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                fill: color,
                            }}
                            fill={color}
                            d="M355.7 167v.4h1.1c.1 0 .3.3.3.5V252c0 .1-.2.4-.3.4h-1.1v.5H354v-86h1.7v.1z"
                        />
                        <path
                            style={{
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                fill: color,
                            }}
                            fill={color}
                            d="M4 217v55H2.2v-.3h-.9c-.1 0-.3-.3-.3-.5v-53c-.1-.2.2-.4.3-.4h.9v-.7H4v-.1z"
                        />
                        <path
                            style={{
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                fill: color,
                            }}
                            fill={color}
                            d="M4 146v55H2.2v-.5h-.9c-.1 0-.3-.3-.3-.5v-53c0-.2.2-.4.3-.4h.9v-.5H4v-.1z"
                        />
                        <path
                            style={{
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                fill: color,
                            }}
                            fill={color}
                            d="M4 95v29H2.1v-.3h-.8c-.1 0-.3-.3-.3-.5v-27c0-.2.2-.4.3-.4h.8v-.7L4 95z"
                        />
                        <path
                            d="M46.1 1h265.7C335.1 1 354 19.9 354 43.1v603.8c0 23.3-18.9 42.1-42.1 42.1H46.1C22.9 689 4 670.1 4 646.9V43.1C4 19.9 22.9 1 46.1 1z"
                            fill="none"
                            stroke={color}
                        />
                    </Phone>
                </PhoneWrap>
            </InView>
        )
    }
}

const InView = styled(Observer)`
  width: 100%;
  height: 100%;
  position: relative;
  padding-left:16px;
  padding-right:16px;

  ${up('md')}{
    display:flex;
    align-self:center;
    padding-left:0;
    padding-right:0;
  }
`

const PhoneWrap = styled.div`
  width: 100%;
  position: relative;

  ${up('md')}{
    width:40vh;
    margin-left:1vh;
  }
`

const Phone = styled.svg`
  width: 100%;
  height: 100%;
`

const PhoneVideo = styled.video`
  position:absolute;
  height:auto;
  width:90%;
  top:9%;
  left:5%;

  ${up('md')}{
    width:36vh;
    top:18vh;
    left:2vh;
  }
`

const LabelWrap = styled.div`
  transform: rotate(90deg);
  transform-origin: 0 0;
  position: absolute;
  display:none;
  line-height: 0px;

  ${up("md")} {
    display: table;
    left: -5%;
    top: 18%;
  }
`

const Label = styled.p`
  font-family: ${TYPE.MONO_FONT};
  font-size: 1.1vh;
  color: ${props => props.color};
  line-height: 0px;
  opacity:.7;
  text-transform:uppercase;
`